export const fileSizeList = [
  {
    value: 10,
    label: '10MB(收集证件照)',
  },
  {
    value: 20,
    label: '20MB(收集照片、一般文档)',
  },
  {
    value: 50,
    label: '50MB(收集短视频)',
  },
  {
    value: 100,
    label: '100MB(收集3分钟左右的视频)',
  },
  {
    value: 200,
    label: '200MB(收集高清图片或视频)',
  },
  {
    value: 500,
    label: '500MB(收集长视频)',
  },
  {
    value: 'other',
    label: '自定义',
  },
]

export const fileMaxNum = 50
